import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2v20l4-4h16V2z"
}), 'ChatBubbleSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ChatBubbleSharp.js
// module id = 2747
// module chunks = 2